/**
 * @ignore
 * Created by daletan on 8/28/16.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');

// Components
const DetailsShipping = require('./DetailsShipping');
const DetailsReturns = require('./DetailsReturns');
const DetailsPaymentMethods = require('./DetailsPaymentMethods');
const DetailsInvoice = require('./DetailsInvoice');
const DetailsDeposit = require('./DetailsDeposit').default;

const ShippingAndReturnsColumn = props => {
    const {
        hasUserId,
        item,
        user,
        quotes,
        context,
        userId,
        itemId,
        itemIsSold,
        itemIsUnlisted,
        dealerPk,
        viewer,
        favoriteDealer,
        favoriteDealerCta,
        dealerData,
        isPrintPage,
    } = props;
    return (
        <div className="pdp-shipping-subcontainer">
            <div className="pdp-shipping-title-container">
                <h2 className="pdp-shipping-title header-primary-large pdp-secondary-header">
                    Shipping & Returns
                </h2>
            </div>
            <div className="rowFlex">
                <div className="pdp-shipping-column colXs12 colLg6">
                    <DetailsShipping
                        context={context}
                        user={user}
                        quotes={quotes}
                        hasUserId={hasUserId}
                        userId={userId}
                        itemIsSold={itemIsSold}
                        itemIsUnlisted={itemIsUnlisted}
                        itemId={itemId}
                        viewer={viewer}
                        dealerPk={dealerPk}
                        favoriteDealer={favoriteDealer}
                        favoriteDealerCta={favoriteDealerCta}
                        dealerData={dealerData}
                        item={item}
                    />
                    <DetailsReturns context={context} item={item} userId={userId} />
                </div>
                <div className="pdp-shipping-column colXs12 colLg6">
                    <DetailsPaymentMethods viewer={viewer} item={item} user={user} />
                    <DetailsDeposit userId={userId} item={item} />
                    <DetailsInvoice
                        context={context}
                        hasUserId={hasUserId}
                        itemId={itemId}
                        userId={userId}
                        viewer={viewer}
                        user={user}
                        isPrintPage={isPrintPage}
                    />
                </div>
            </div>
        </div>
    );
};

ShippingAndReturnsColumn.defaultProps = {
    isPrintPage: false,
};

ShippingAndReturnsColumn.propTypes = {
    isPrintPage: PropTypes.bool,
    context: PropTypes.object,
    itemId: PropTypes.string,
    itemIsSold: PropTypes.bool,
    itemIsUnlisted: PropTypes.bool,
    hasUserId: PropTypes.bool,
    userId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    item: PropTypes.object,
    user: PropTypes.object,
    quotes: PropTypes.object.isRequired,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object,
};

module.exports = Relay.createContainer(ShippingAndReturnsColumn, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null,
    },
    fragments: {
        user: ({ hasUserId, itemId, userId }) => Relay.QL`
            fragment on User {
                ${DetailsShipping.getFragment('user', { hasUserId, itemId, userId })}
                ${DetailsPaymentMethods.getFragment('user')}
            }
        `,
        item: ({ hasUserId, itemId, userId }) => Relay.QL`
            fragment on Item {
                ${DetailsShipping.getFragment('item', { hasUserId, itemId, userId })}
                ${DetailsReturns.getFragment('item', { userId })}
                ${DetailsPaymentMethods.getFragment('item')}
                ${DetailsDeposit.getFragment('item', { userId })}
            }
        `,
        viewer: ({ hasUserId, itemId, userId }) => Relay.QL`
            fragment on Viewer {
                ${DetailsShipping.getFragment('viewer', { hasUserId, itemId, userId })}
                ${DetailsInvoice.getFragment('viewer', { hasUserId, itemId, userId })}
                ${DetailsPaymentMethods.getFragment('viewer')}
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ShippingAndReturnsColumn.jsx